import { parseDateKey, toJerusalemDateKey } from '../utils/date';
import { fetchJson } from './network';

export async function getDailyLearning(date, { signal } = {}) {
  const { day, month, year } = parseDateKey(toJerusalemDateKey(date));
  const json = await fetchJson(
    `https://www.sefaria.org.il/api/calendars?timezone=Asia/Jerusalem&day=${day}&month=${month}&year=${year}&diaspora=0&custom=ashkenazi`,
    { signal }
  );
  return Array.isArray(json.calendar_items) ? json.calendar_items : [];
}
